export class FiltrosAdquirentePago{
    IdAdqui : string = '';
    Moneda : number = 0;
    Banco : number = 0;
    Estado : string = 'P';
 }
